import { BONUS_OFFERS_FLEX_PAGE_VIEW, BONUS_OFFERS_FLEX_PAGE_SECTION_VIEW } from './types';

export const triggerBonusOffersFlexPageIsViewed = offer => ({
  type: BONUS_OFFERS_FLEX_PAGE_VIEW,
  offer,
});

export const triggerBonusOffersFlexPageSectionIsViewed = (sectionHeadline, bonusOffersLength) => ({
  type: BONUS_OFFERS_FLEX_PAGE_SECTION_VIEW,
  sectionHeadline,
  bonusOffersLength,
});
